/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedStudentTypeList200,
  GetApiV1CourseregistrationSharedStudentTypeList401,
  GetApiV1CourseregistrationSharedStudentTypeList500,
  GetApiV1CourseregistrationSharedStudentTypeListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedStudentTypeList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedStudentTypeList200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1CourseregistrationSharedStudentTypeList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedStudentTypeList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedStudentTypeList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedStudentTypeList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedStudentTypeList500>;

export const getApiV1CourseregistrationSharedStudentTypeListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedStudentTypeList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedStudentTypeListQueryResponse>;
